import React, { useState } from "react";
import Activity from "../../models/Activity";
import { Animated, Image, Platform, StyleSheet, TouchableOpacity, ViewStyle } from "react-native";
import AppTheme from "../../utils/Theme";
import View from "../ReactNative/View";
import { getVideoUrlForMediaId } from "../../../specific/services/AppWrite/AppWriteDatabase";
import Modal from "../../../specific/components/Modal/Modal";
import LiliVideoPlayer from "../../../specific/components/VideoPlayer/LiliVideoPlayer";
import NavBarButton from "../NavBar/NavBarButton";

import { default as IcVideo } from "../../assets/svg/icons/solid/film.svg";
import { default as IcBack } from "../../assets/svg/lili/ic_back_arrow.svg";
import { IcClose } from "../../utils/Icons";
import Images from "../../../specific/utils/Images";
import { getImageSource } from "../../utils/Images/ImagesUtils";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import Text from "../ReactNative/Text";

interface ActivityHeaderImageProps {
    activity: Activity;
    onCloseRequest: () => void;
    showButton?: boolean;
    isModal?: boolean;
    fixedWidth?: number;
    fullImage?: boolean;
    color?: string;
}

const ActivityHeaderImage = (props: ActivityHeaderImageProps) => {

    const { activity, onCloseRequest, showButton = false, isModal = false, fixedWidth, fullImage = true, color = "#FFFFFF" } = props;

    console.log({ur: activity.img_url});

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();

    const {
        contentSize,
        horizontalSpacing
    } = useSpecificSize();

    const contentWidth: number = fixedWidth !== undefined ? fixedWidth : contentSize;
    const headerWidth: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? contentWidth - 2 * horizontalSpacing : contentWidth;

    const [showVideo, setShowVideo] = useState<boolean>(false);

    const closeTheVideoModal = () => {
        setShowVideo(false);
    }

    const goBack = () => {
        onCloseRequest();
    }

    const getVideoModal = (): React.JSX.Element | null => {
        if (showVideo === true) {
            let videoUrl = activity.header.url;
            videoUrl = getVideoUrlForMediaId({ media_id: activity.key + "_header" });
            return <LiliVideoPlayer
                repeat={true}
                backgroundColor={appTheme.darkBlue}
                url={videoUrl}
                closeTheDocument={closeTheVideoModal} />
        }
        return null;
    }

    const imageWidth: number = headerWidth;
    const headerImageHeight: number = Platform.OS === "web" ? imageWidth * 9 / 36 : imageWidth * 27 / 36;
    let headerStyle: ViewStyle = {
        width: contentWidth,
        height: headerImageHeight + appTheme.pixelPerfect(20) + appTheme.topInsets,
        backgroundColor: appTheme.white
    }
    let videoButton = <View />;
    if ((activity.header !== undefined) && (activity.header.type !== undefined) && (activity.header.type == "vid")) {
        if ((activity.header.url !== undefined) && ((activity.header.url.length > 0))) {
            const rightPosition = Platform.OS === "web" ? imageWidth / 6 : appTheme.pixelPerfect(5);
            videoButton = <View style={{ position: "absolute", bottom: appTheme.pixelPerfect(5), right: rightPosition }}>
                <NavBarButton icon={IcVideo} action={() => setShowVideo(true)} />
            </View>;
        }
    }
    if (Platform.OS !== "web") {
        headerStyle.height = headerImageHeight + appTheme.topInsets;
    }
    const imageBorderRadius = Platform.OS == "web" ? appTheme.pixelPerfect(15) : 0;
    let backButton: React.JSX.Element = <View />;
    if ((Platform.OS === "web") || (showButton === true)) {
        backButton = <View style={{ position: "absolute", top: appTheme.topInsets > 0 ? appTheme.topInsets : appTheme.pixelPerfect(10), left: appTheme.pixelPerfect(10) }}>
            <NavBarButton action={goBack} icon={((Platform.OS === "web") || (isModal === true)) ? IcClose : IcBack} />
        </View>
    }
    const bgColor: string = Platform.OS === "web" ? color : ((activity.colors !== undefined) && (activity.colors.top !== undefined)) ? activity.colors.top : color;
    let fullHeaderHeight: number = Platform.OS === "web" ? fullImage === false ? headerImageHeight : headerImageHeight + appTheme.pixelPerfect(20) : headerImageHeight;
    fullHeaderHeight = fullHeaderHeight + appTheme.topInsets;
    const resizeMode: "cover" | "contain" = fullImage === true ? "cover" : "contain";
    return <View style={{ width: contentWidth, alignItems: "center" }}>
        <View style={[headerStyle]}>
            <View style={{ backgroundColor: bgColor, width: "100%", height: fullHeaderHeight, justifyContent: "flex-start", alignItems: "center"}}>
                <Image source={getImageSource({ app_image: activity.app_image, img_url: activity.img_url })} style={{ width: imageWidth, height: fullHeaderHeight, borderRadius: imageBorderRadius }} resizeMode={resizeMode} />
            </View>
            {videoButton}
            {backButton}
            <Modal animationType="slide" visible={showVideo} transparent={true} style={{ width: appTheme.getFullScreenWidth() }}>
                <View style={{ flex: 1, alignItems: "center", backgroundColor: "transparent", width: appTheme.getFullScreenWidth() }}>
                    <View style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: appTheme.darkBlue + "80", height: appTheme.getFullAppHeight(), width: appTheme.getFullAppWidth() }}>
                        {getVideoModal()}
                    </View>
                </View>
            </Modal>
        </View>

    </View>
}

export default ActivityHeaderImage;